import { patchMe } from '../../century-core/core-apis/accountsV2/users/users';
import { createFetchRequestWithLocalisedError } from 'century-core/core-apis/utils';

export async function changeAvatar(avatar: string, accessToken: string): Promise<{ _id: string; id: string }> {
  return createFetchRequestWithLocalisedError(
    () => patchMe(accessToken, { profile: { avatar } }),
    'localised-errors-user-profile-generic-error'
  );
}
